import { compose, defaultProps } from 'recompose'
import withType from 'components/common/hoc/withType'
import BOTSearchTiresBySizePanel from 'components/BOTSearchTiresBySizePanel'

export default compose(
  withType({ type: 'BOTSearchTrailerTiresPanel' }),
  defaultProps({
    purpose: 'trailer',
    queryParams: ''
  })
)(BOTSearchTiresBySizePanel)
